export enum StockDataSource {
  ASX200 = 'ASX200',
  AllAU = 'AllAU',
  DJDJI = 'DJDJI',
  NASDAQ100 = 'NASDAQ100',
  SPX500 = 'SPX500',
  AllUSA = 'AllUSA'
}

export enum EtfDataSource {
  AllAUEtf = 'AllAUEtf',
  AllUSEtf = 'AllUSEtf',
  AllSGPEtf = 'AllSGPEtf',
  AllNZEtf = 'AllNZEtf'
}

export enum ColorTheme {
  Light = 'light',
  Dark = 'dark'
}

export const EtfStorageKey = 'Dashboard.ETFHeatMap.DataSource';

export const StockStorageKey = 'Dashboard.StockHeatMap.DataSource';
